var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.3335V13.445C15 13.8574 14.8361 14.253 14.5445 14.5447C14.2528 14.8363 13.8573 15.0002 13.4448 15.0002H2.55519C2.14273 15.0002 1.74716 14.8363 1.4555 14.5447C1.16385 14.253 1 13.8574 1 13.445V10.3335",
    stroke: "#707070",
    strokeWidth: 1.10532,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10467 6.44473L7.99429 10.3333L11.8828 6.44473",
    stroke: "#707070",
    strokeWidth: 1.10532,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99414 10.3333L7.99414 0.99992",
    stroke: "#707070",
    strokeWidth: 1.10532,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.c8f73cb7212dfa6953f12f5512d5ef4a.svg";
export { ForwardRef as ReactComponent };